// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"120d8712","127":"2d51c675","149":"c6d00266","454":"25045148","520":"f950c17a","553":"772cb3c9","653":"916f620b","750":"c3702eb9","854":"e337f605","858":"792425cb"}[chunkId] + ".chunk.js";
};